"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const videoStyles_1 = require("../../styling/videoStyles");
const styles_1 = require("./styles");
const MultistreamPlayersGrid = (0, react_1.forwardRef)(({ children, classes }, ref) => {
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes !== null && classes !== void 0 ? classes : {}, target: styles_1.playerGridWrapperStyles }, "multistream-players-grid");
    return (react_1.default.createElement("div", { ref: ref, className: mergedClasses.root }, children));
});
exports.default = MultistreamPlayersGrid;
//# sourceMappingURL=index.js.map